var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('d-button',{class:_vm.btnLoading ? _vm.btn.class + ' disabled' : _vm.btn.class,attrs:{"text":_vm.btn.label,"icon":_vm.btnLoading ? 'fa fa-spinner fa-spin' : _vm.btn.icon},on:{"on:button-click":_vm.exportToPdf}})}
var staticRenderFns = []

export { render, staticRenderFns }